import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  useGetAllJobLiningByIdQuery,
  useGetSelectByIdApiQuery,
  useGetUserDetailByIdQuery,
} from "../../../services/api";

import AddNewLog from "../FinishedGoodsPreview/addNewLog";
import LoginHistory from "../FinishedGoodsPreview/loginHistory";
import WarehouseTab from "../FinishedGoodsPreview/warehouse";
import VendorTab from "../RawMaterialPreview/vendor";
// import "./index.css";
import ForLiningDetailPreview from "./productDetail";

interface ICreateSales {
  setId: (data: string) => void;
  setActive: (data: boolean) => void;
  setOpenDrawer: (data: boolean) => void;
}
export const ForLiningPreview: React.FC<ICreateSales> = ({
  setId,
  setActive,
  setOpenDrawer,
}) => {
  const [open, setOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const log = searchParams.get("log");

  const { data, isLoading, refetch } = useGetAllJobLiningByIdQuery(Number(id), {
    skip: !id,
  });
  useEffect(() => {
    refetch();
  }, []);
  const ratingData = [
    "Cost",
    "Quality",
    "Credit terms",
    "Reliability",
    "Logistic chain",
    "Communication",
  ];

  useEffect(() => {
    if (id) {
      setId(data?.data?.job_id as string);
      setActive(data?.data?.is_active as boolean);
    }
  }, [id, data?.data?.job_id]);
  const [activeTab, setActiveTab] = useState("1");

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };
  const { data: selectById } = useGetSelectByIdApiQuery("joblining");

  const userId = localStorage.getItem("user_id");

  const { data: userDetail } = useGetUserDetailByIdQuery(userId);
  useEffect(() => {
    if (log) {
      setActiveTab("4");
    }
  }, [log]);
  return (
    <>
      <Tabs
        className="finishedGoodsTab"
        activeKey={activeTab}
        onChange={handleTabChange}
        type="card"
        items={
          localStorage?.getItem("user_role") === "2" ||
          localStorage?.getItem("user_role") === "1"
            ? [
                {
                  label: "Product Details",
                  key: "1",
                  children: (
                    <ForLiningDetailPreview
                      setActive={setActive}
                      setId={setId}
                      data={data?.data as any}
                      isLoading={isLoading as boolean}
                      setOpenDrawer={setOpenDrawer}
                    />
                  ),
                },
                {
                  label: "Vendor Details",
                  key: "2",
                  children: <VendorTab data={data?.data as any} />,
                },
                {
                  label: "Warehouse Details",
                  key: "3",
                  children: (
                    <WarehouseTab
                      data={data?.data as any}
                      sku={data?.data?.storage_unit as string}
                    />
                  ),
                },
              ]
            : [
                {
                  label: "Product Details",
                  key: "1",
                  children: (
                    <ForLiningDetailPreview
                      setActive={setActive}
                      setId={setId}
                      data={data?.data as any}
                      isLoading={isLoading as boolean}
                      setOpenDrawer={setOpenDrawer}
                    />
                  ),
                },
                ...(data?.data?.type !== "internal"
                  ? [
                      {
                        label: "Vendor Details",
                        key: "2",
                        children: <VendorTab data={data?.data as any} />,
                      },
                    ]
                  : []),

                {
                  label: "Warehouse Details",
                  key: "3",
                  children: (
                    <WarehouseTab
                      data={data?.data as any}
                      sku={data?.data?.storage_unit as string}
                    />
                  ),
                },
                ...(data?.data?.is_active
                  ? [
                      {
                        label: "Log Inwards/Outwards",
                        key: "4",
                        children: open ? (
                          <AddNewLog
                            data={data?.data as any}
                            inventory_type="joblining"
                            defaultCategoryId={selectById?.id as number}
                            setOpen={setOpen}
                            path="/for-lining"
                            stock_qty={data?.data?.quantity as number}
                          />
                        ) : (
                          <LoginHistory
                            modelId={Number(selectById?.id as number)}
                            objectId={Number(id)}
                            setOpen={setOpen}
                          />
                        ),
                      },
                    ]
                  : []), // Only include this tab if is_active is true
              ]
        }
      />
    </>
  );
};

export default ForLiningPreview;
